import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
var CLIENT_SESSION_COOKIE_NAME = "CLIENT-TOKEN";
var CLIENT_SESSION_QUERY_NAME = "session";
/** Gets the JWT base64 encoded client session token from cookie. */ export var getSessionTokenFromCookie = function() {
    var token = Cookies.get(CLIENT_SESSION_COOKIE_NAME);
    if (!token) {
        return null;
    }
    return token;
};
/**
 * Gets the JWT base64 encoded client session token from query string.
 *
 * This is used as a fallback to retrieve feature flags within iframes.
 */ var getSessionTokenFromQuery = function() {
    var token = new URLSearchParams(window.location.search).get(CLIENT_SESSION_QUERY_NAME);
    if (!token) {
        return null;
    }
    return token;
};
/**
 * Gets session claims from the JWT cookie and decodes them.
 *
 * @param token Optionally override the token to be decoded (for unit testing).
 */ export var getSessionClaims = function() {
    var token = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getSessionTokenFromCookie() || getSessionTokenFromQuery();
    if (!token) {
        return null;
    }
    var claims = jwt_decode(token);
    if (!claims) {
        throw new Error("Claims could not be decoded.");
    }
    return claims;
};
